import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullscreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_307_5668)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_307_5668",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgFullscreen;
